export default __webpack_public_path__ + "static/media/twitter-white.fbe0f2fe.svg";